import React from "react";

export default function renderIcon({
  width = 21,
  height = 21,
  color = "#9ca2b8",
}) {
  return (
    <svg
      width="116"
      height="32"
      viewBox="0 0 116 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.9314 6.68904C20.9189 5.53264 20.3608 4.04782 20.3609 2.51074H15.7827V20.8834C15.7481 21.8779 15.3286 22.8201 14.6127 23.5111C13.8967 24.2022 12.9403 24.5882 11.9453 24.5876C9.84136 24.5876 8.09304 22.8688 8.09304 20.7352C8.09304 18.1868 10.5525 16.2754 13.0861 17.0607V12.3786C7.97451 11.6971 3.5 15.6679 3.5 20.7352C3.5 25.6692 7.58929 29.1807 11.9305 29.1807C16.5828 29.1807 20.3609 25.4025 20.3609 20.7352V11.4156C22.2174 12.7488 24.4463 13.4642 26.7319 13.4603V8.88191C26.7319 8.88191 23.9464 9.01526 21.9314 6.68904Z"
        fill="#FFFFFF"
      />
      <path
        d="M30.8867 9.60938H44.5863L43.3282 13.542L39.7744 13.5404V28.0796H35.3459V13.5404L30.8899 13.5485L30.8867 9.60938Z"
        fill="#FFFFFF"
      />
      <path
        d="M67.0312 9.60938H81.0482L79.7901 13.542L75.9254 13.5404V28.0796H71.4904V13.5404L67.0345 13.5485L67.0312 9.60938Z"
        fill="#FFFFFF"
      />
      <path
        d="M45.4219 15.4854H49.815L49.8101 28.0801H45.4493L45.4219 15.4854Z"
        fill="#FFFFFF"
      />
      <path
        d="M51.5547 9.55664H55.9429V18.1589L60.2909 13.8772H65.5282L60.0283 19.2322L66.1887 28.0786H61.3542L57.243 21.9444L55.9429 23.2133V28.0802H51.5547V9.55664Z"
        fill="#FFFFFF"
      />
      <path
        d="M98.0469 9.55664H102.435V18.1589L106.783 13.8772H112.02L106.521 19.2322L112.681 28.0786H107.846L103.735 21.9444L102.435 23.2133V28.0802H98.0469V9.55664Z"
        fill="#FFFFFF"
      />
      <path
        d="M47.6165 14.0447C48.8372 14.0447 49.8267 13.0518 49.8267 11.827C49.8267 10.6023 48.8372 9.60938 47.6165 9.60938C46.3958 9.60938 45.4062 10.6023 45.4062 11.827C45.4062 13.0518 46.3958 14.0447 47.6165 14.0447Z"
        fill="#FFFFFF"
      />
      <path
        d="M87.9292 13C83.7794 13 80.4141 16.375 80.4141 20.5403C80.4141 24.7041 83.7778 28.0807 87.9292 28.0807C92.0806 28.0807 95.4443 24.7057 95.4443 20.5403C95.4443 16.375 92.0806 13 87.9292 13ZM87.9292 24.2046C85.9123 24.2046 84.2755 22.564 84.2755 20.5387C84.2755 18.515 85.9107 16.8728 87.9292 16.8728C89.9477 16.8728 91.5829 18.5134 91.5829 20.5387C91.5829 22.564 89.9477 24.2046 87.9292 24.2046Z"
        fill="#FFFFFF"
      />
    </svg>
  );
}
